import {GROUPS} from "../../../utils/constants";
import {timestampToDate} from "../../../utils/date";

export const getGroupPathByName = (name: string) => {
  return GROUPS.find(group => group.name === name)?.path || ''
}

const dateToString = (date) => {
  if (!date) return '';

  const pad = (n) => n.toString().padStart(2, '0');

  const yyyy = date.getFullYear();
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const HH = pad(date.getHours());
  const MM = pad(date.getMinutes());
  const SS = pad(date.getSeconds());

  return `${yyyy}-${mm}-${dd} ${HH}:${MM}:${SS}`;
}

export const timestampToDateTimeString = (ts) => {
  const date = timestampToDate(ts);
  return dateToString(date);
};
